export default "__VITE_ASSET__1gizKc66__"